/* eslint-disable */
/* tslint:disable */
/* Do not edit - generated by swagger-typescript-api */

import {
  AiPromptCreateRequest,
  AiPromptResponseDataResponse,
  AiPromptSaveRequest,
  AiPromptSummaryResponseCollectionResponse,
  AiPromptWriteResultDataResponse,
  ErrorResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';
export class AiPrompts<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;
  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }
  /**
   * No description
   *
   * @tags AiPrompts
   * @name GetAiPrompts
   * @request GET:/AiPrompts
   * @response `200` `AiPromptSummaryResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getAiPrompts = (params: RequestParams = {}) =>
    this.http.request<AiPromptSummaryResponseCollectionResponse, ErrorResponse>({
      path: `/AiPrompts`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AiPrompts
   * @name CreateAiPrompt
   * @request POST:/AiPrompts
   * @response `201` `AiPromptWriteResultDataResponse` Created
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  createAiPrompt = (data: AiPromptCreateRequest, params: RequestParams = {}) =>
    this.http.request<AiPromptWriteResultDataResponse, ErrorResponse>({
      path: `/AiPrompts`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AiPrompts
   * @name GetAiPrompt
   * @request GET:/AiPrompts/{id}
   * @response `200` `AiPromptResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getAiPrompt = (id: number, params: RequestParams = {}) =>
    this.http.request<AiPromptResponseDataResponse, ErrorResponse>({
      path: `/AiPrompts/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AiPrompts
   * @name SaveAiPrompt
   * @request PUT:/AiPrompts/{id}
   * @response `200` `AiPromptWriteResultDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  saveAiPrompt = (id: number, data: AiPromptSaveRequest, params: RequestParams = {}) =>
    this.http.request<AiPromptWriteResultDataResponse, ErrorResponse>({
      path: `/AiPrompts/${id}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AiPrompts
   * @name DeleteAiPrompt
   * @request DELETE:/AiPrompts/{id}
   * @response `204` `void` No Content
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  deleteAiPrompt = (id: number, params: RequestParams = {}) =>
    this.http.request<void, ErrorResponse>({
      path: `/AiPrompts/${id}`,
      method: 'DELETE',
      ...params,
    });
  /**
   * No description
   *
   * @tags AiPrompts
   * @name GetAiPromptVersions
   * @request GET:/AiPrompts/{id}/Versions
   * @response `200` `AiPromptResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getAiPromptVersions = (id: number, params: RequestParams = {}) =>
    this.http.request<AiPromptResponseDataResponse, ErrorResponse>({
      path: `/AiPrompts/${id}/Versions`,
      method: 'GET',
      format: 'json',
      ...params,
    });
}
